import PageStart from "./page_start";

export default App;

function App() {
  return <PageStart />;
}
